import React from 'react'
import { useNavigate } from 'react-router-dom'

import moment from 'moment'

import { useShiftActions } from 'modules/attendance/hooks/shifts/useShiftActions'

import useData from './useData'

const COMPONENT_REFRESH_INTERVAL = 60 * 1000 // 60 sec

export default function withHooks(Component: any) {
  const ComponentWithHooks = (props: any) => {
    const navigate = useNavigate()
    const now = moment().unix()
    const [timestamp, setTimestamp] = React.useState(now) // Used to refresh the view
    const shiftActions = useShiftActions()

    const {
      today,
      setToday,
      loading,
      openShift,
      lastWorkingShift,
      onRefresh,
      setLoading,
      breakSetting,
      checkRefreshData,
      attendanceSetting,
      breaksEnabled,
      breakDurationRules,
      todayShifts,
      estimatedTime,
      policies,
      desktopClockIn,
      mobileClockIn,
      canSeeOwnedAttendance,
      breakConfigurations,
      breakTypes,
    } = useData()

    React.useEffect(() => {
      const interval = setInterval(() => {
        setTimestamp(moment().unix())
        checkRefreshData()
      }, COMPONENT_REFRESH_INTERVAL)

      return () => clearInterval(interval)
    }, [checkRefreshData])

    React.useEffect(() => {
      document.addEventListener('visibilitychange', checkRefreshData)

      return () => {
        document.removeEventListener('visibilitychange', checkRefreshData)
      }
    }, [checkRefreshData])

    return (
      <Component
        minute={timestamp}
        today={today}
        setToday={setToday}
        loading={loading}
        openShift={openShift}
        lastWorkingShift={lastWorkingShift}
        onRefresh={onRefresh}
        setLoading={setLoading}
        breakSetting={breakSetting}
        navigate={navigate}
        attendanceSetting={attendanceSetting}
        shiftActions={shiftActions}
        breakDurationRules={breakDurationRules}
        todayShifts={todayShifts}
        estimatedTime={estimatedTime}
        policies={policies}
        desktopClockIn={desktopClockIn}
        mobileClockIn={mobileClockIn}
        canSeeOwnedAttendance={canSeeOwnedAttendance}
        breakConfigurations={breakConfigurations}
        breakTypes={breakTypes}
        breaksEnabled={breaksEnabled}
        {...props}
      />
    )
  }
  ComponentWithHooks.displayName = 'withHooks'

  return ComponentWithHooks
}
